import { FORMATION_STATS, FormationType, nextFormation, writeFormationTargets } from './formations';
import { approach } from '../math/scalar';
import type { PlayerState } from '../player/PlayerState';

export class PrismNodes {
  readonly x = new Float32Array(3);
  readonly y = new Float32Array(3);
  readonly targetX = new Float32Array(3);
  readonly targetY = new Float32Array(3);
  readonly charge = new Float32Array(3);
  readonly disabledTicks = new Float32Array(3);
  readonly fireCooldown = new Float32Array(3);
  readonly pulse = new Float32Array(3);
  formation = FormationType.Front;
  directionIndex = 0;
  orbitPhase = 0;
  tetherCharge = 0;
  tetherActiveTicks = 0;

  reset(player: PlayerState): void {
    this.formation = FormationType.Front;
    this.directionIndex = 0;
    this.orbitPhase = 0;
    this.tetherCharge = 0;
    this.tetherActiveTicks = 0;
    writeFormationTargets(this.formation, this.orbitPhase, this.targetX, this.targetY);
    for (let i = 0; i < 3; i += 1) {
      this.x[i] = player.x + (this.targetX[i] ?? 0);
      this.y[i] = player.y + (this.targetY[i] ?? 0);
      this.charge[i] = 1;
      this.disabledTicks[i] = 0;
      this.fireCooldown[i] = 0;
      this.pulse[i] = 0;
    }
  }

  cycleFormation(): void {
    this.formation = nextFormation(this.formation);
  }

  rotateDirection(delta: number): void {
    this.directionIndex = (this.directionIndex + delta + 8) & 7;
  }

  update(player: PlayerState, repairFieldActive: boolean): void {
    // HOTPATH-BEGIN
    this.orbitPhase += this.formation === FormationType.Orbit ? 0.035 : 0.008;
    writeFormationTargets(this.formation, this.orbitPhase, this.targetX, this.targetY);
    const stats = FORMATION_STATS[this.formation];
    const recharge = (0.0024 + player.nodeRechargeLevel * 0.00065) * stats.rechargeScale * (repairFieldActive ? 2.6 : 1);
    for (let i = 0; i < 3; i += 1) {
      this.x[i] = approach(this.x[i], player.x + this.targetX[i], 2.8);
      this.y[i] = approach(this.y[i], player.y + this.targetY[i], 2.8);
      if (this.disabledTicks[i] > 0) this.disabledTicks[i] -= 1;
      else if (this.charge[i] < 1) this.charge[i] += recharge;
      if (this.charge[i] > 1) this.charge[i] = 1;
      if (this.fireCooldown[i] > 0) this.fireCooldown[i] -= 1;
      if (this.pulse[i] > 0) this.pulse[i] -= 1;
    }
    if (this.tetherActiveTicks > 0) this.tetherActiveTicks -= 1;
    else if (this.tetherCharge < 1) this.tetherCharge += 0.0022;
    // HOTPATH-END
  }
}
